// extracted by mini-css-extract-plugin
module.exports = {"item":"InfoHistoryTable_item__qDAPD","itemRevert":"InfoHistoryTable_itemRevert___gq1t"};